import { Button, Layout, Space } from 'antd';
import { Content, Header } from 'antd/es/layout/layout';
import { useEffect, useState } from 'react';
import { CConfigPart, NamespacedCCParts } from '../../apis/mgmt/api';
import { DataViewProps } from '../common/DataView';
import CCEditor from './cceditor';

export const NamespacedCCPartsForm = (
    props: DataViewProps<NamespacedCCParts>
) => {

    const namespace = props.data?.namespace;

    const [selectedTab, setSelectedTab] = useState<number>(0);
    const selectedTabStyle = (tab: number ) => selectedTab === tab ? {} : { 'display': 'none' };
    const defaultConfig = '# Add your configuration here or delete all to get the sample configuration';
    useEffect(() => {
        if (!props.data || !props.data.parts || selectedTab>=props.data.parts.length) {
            setSelectedTab(0);
        }
    }, [props.data?.parts?.length]);

    const editTabKey = (e: any) => {
        const el = e.target;
        //if (el.contentEditable) return;
        el.innerHTML = el.innerText.replace(/[^a-zA-Z0-9]/g, '');
        el.setAttribute('contenteditable', true);
        el.focus(); // Focus on the input which will activate editing
        document.execCommand('selectAll',false);
    }

    const editTabKeyFinishIfReturnOrEscape = (e: any, index?: number) => {
        if (index===undefined) index = props.data?.parts?.length || 0;
        const el = e.target;
        //if (!el.contentEditable) return;
        if (e.key === 'Enter') {
            e.stopPropagation();
            el.blur();
        } else if (e.key === 'Escape') {
            const parts = props.data?.parts || [];
            if (index >= parts.length) el.innerHTML = '+';
            else el.innerHTML = parts[index].key;
            e.stopPropagation();
            el.blur();
        }
    }

    const onTabKeyChanged = (e: any, index?: number) => {
        if (!props.data || !props.data.namespace) return;
        if (index===undefined) index = props.data?.parts?.length || 0;
        const el = e.target;
        el.setAttribute('contenteditable', false);
        const key = el.innerText.replace(/[^a-zA-Z0-9]/g, '');
        const parts = props.data.parts || [];
        if (parts) {
            if (!key && index<parts.length) { // Remove tab
                parts.splice(index, 1)
                if (index >= parts.length) index = parts.length -1;
                if (index < 0) index = 0;
            } else if (index>=parts.length) {  // Add new tab
                if (!key) {
                    el.innerHTML = '+';
                    return;
                }
                parts.push({
                    path: namespace?.replace('.*', ''),
                    key: key, config: defaultConfig
                });
            } else { // Update tab
                parts[index].key = key;
            }
        }
        props.data.parts = parts;
        props.setData(props.data);
        setSelectedTab(index);
    }

    return (
        <Layout className="h-100" >
            {namespace?.endsWith('.*') &&
                <Header style={{ 'paddingBottom': '1em' }}>
                    <Space.Compact direction="horizontal" >
                        {props.data?.parts?.map((part: CConfigPart, index: number) => (
                            <Button key="{part.key}" className={index==selectedTab? 'tab selected' : 'tab'} type="text" 
                                onClick={()=> setSelectedTab(index)}
                            ><span contentEditable="true" 
                                onDoubleClick={editTabKey}
                                onBlur={(e)=>{onTabKeyChanged(e, index)}}
                                onKeyDown={(e)=>{editTabKeyFinishIfReturnOrEscape(e, index)}}
                                >{part.key}</span>
                            </Button>
                        ))}
                        <Button className="tab" type="text"><span 
                            onDoubleClick={editTabKey}
                            onBlur={(e)=>{onTabKeyChanged(e)}}
                            onKeyDown={(e)=>{editTabKeyFinishIfReturnOrEscape(e)}}
                            >+</span>
                        </Button>
                    </Space.Compact>
                </Header>
            }
            <Content className="h-100">
                { props.data?.parts?.map((part: CConfigPart, index: number) => (
                    <div key="{part.key}" style={selectedTabStyle(index)} className="h-100">
                        <CCEditor 
                            data={(!namespace?.endsWith('.*') && !part.id && !part.config? defaultConfig : part.config) || ''} 
                            setData={(data: string | undefined) => {
                                if (props.data && props.data.parts) {
                                    props.data.parts[index].config = data || props.data?.sampleConfig || '';
                                    props.setData(props.data);
                                }
                            }} 
                            language={ namespace?.endsWith('.python') && 'python' || 'yaml' }
                        />
                    </div>
                ))}
            </Content>
        </Layout>
    );

};